






import Vue from 'vue'

interface ComponentData {

}

export default Vue.extend({
  name: 'ProjectNotes',

  components: {

  },

  props: {

  },

  data (): ComponentData {
    return {

    }
  },

  watch: {

  },

  computed: {

  },

  methods: {

  },

  mounted () {

  }
})
